import { render, staticRenderFns } from "./KombiTooltip.vue?vue&type=template&id=28d568d8&"
import script from "./KombiTooltip.vue?vue&type=script&lang=js&"
export * from "./KombiTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports